const modelProduct = (data: CurrentRelatedProduct | PublisherProduct) => ({
  id: data.id,
  product_sku: data.product_sku,
  name: data.name,
  image: data.image_url,
  active: data.active,
  gtin: data.gtins,
  reference: data.additional_references,
  productReference: data.product_reference_code,
  categories: data.categories,
  seller_id: data.seller_id,
  isSuggested: data?.isSuggested,
  publisher_id: data?.publisher_id,
})

export default modelProduct
